import React from 'react';
import PropTypes from 'prop-types';
import Markup from 'components/Markup';
import { Box, Heading } from 'roo-ui/components';

const RoomDescription = ({ description }) => (
  <Box mb={[0, 5]} pb={5} borderBottom={[1, 0]} borderColor="greys.alto">
    <Heading.h5 fontSize="md" color="greys.charcoal" data-testid="description-title">
      Room Information
    </Heading.h5>
    <Box mt={2}>
      <Markup data-testid="description-copy" content={description} />
    </Box>
  </Box>
);

RoomDescription.propTypes = {
  description: PropTypes.string.isRequired,
};

export default RoomDescription;
